'use strict';

import './sponsoredFinanceAd.scss';
import template from './sponsoredFinanceAd.template.html';
import controller from './sponsoredFinanceAd.controller.js';

const component = {
    bindings: {
        new: '=',
        used: '=',
        term: '='
    },
    controller,
    template
};

export default component;
